import React, { useState } from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [companyOpen, setCompanyOpen] = useState(false);

  const handleLinkClick = () => {
    setMenuOpen(false);
    setCompanyOpen(false);
  };

  return (
    <nav className="navbar navbar-default navbar-fixed-top">
      <div className="nav-wrapper container">
        <div className="navbar-header">
          <div itemScope itemType="http://schema.org/Organization" className="logo">
            <a itemProp="url" href="/" className="navbar-brand">
              <img
                itemProp="logo"
                src="/img/svg/logo.svg"
                alt="SmartVizX - Bespoke design, tech-enabled delivery"
                title="SmartVizX - Bespoke design, tech-enabled delivery"
              />
            </a>
          </div>

          {/* Hamburger icon */}
          <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        <div className={`navbar-collapse ${menuOpen ? 'collapse' : ''}`}>
          <ul className="nav navbar-nav navbar-right">
            <li className="menu" onClick={handleLinkClick}>
              <a href="/products"><span className="slide-text">Our Work</span></a>
            </li>
            <li
              className={`menu ${companyOpen ? 'open' : ''}`}
              onClick={() => setCompanyOpen(!companyOpen)}
            >
              <a><span className="slide-text">Company</span></a>
              <ul className="submenu box" onClick={handleLinkClick}>
                <li><Link to="/about">About</Link></li>
                <li><a href="/press">Press</a></li>
                <li><Link to="/career">Careers</Link></li>
                <li><a href="/clients">Clients</a></li>
              </ul>
            </li>
            <li onClick={handleLinkClick}>
              <a href="https://trezi.com"><span className="slide-text">Product</span></a>
            </li>
            <li onClick={handleLinkClick}>
              <a href="/blog"><span className="slide-text">Blog</span></a>
            </li>
            <li onClick={handleLinkClick}>
              <a href="/contact"><span className="slide-text">Contact</span></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
